import React from "react";

import styled from "styled-components/macro";

import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import { motion } from "framer-motion";

export default function AmountSuggestions({ setSuggestionButtonAmount }) {
  const {
    state: {
      fund: {
        paymentPageSettings: { suggestedAmounts },
      },
    },
  } = usePaymentPage();

  const setAmount = (amount) => {
    setSuggestionButtonAmount(amount);
  };

  const list = {
    show: {
      opacity: 1,
      transition: {
        delayChildren: 0.2,
        staggerChildren: 0.1,
      },
    },
    hidden: {
      opacity: 0,
    },
  };

  const sortedSuggestions = suggestedAmounts
    .filter((x) => x > 0)
    .sort((a, b) => (a > b ? 1 : -1));

  return (
    <Wrapper initial="hidden" animate="show" variants={list}>
      <Inside>
        {sortedSuggestions.map((amount) => (
          <Button
            key={amount}
            amount={amount}
            setAmount={setAmount}
            data-cy="fund-it-fund-amount-suggestion"
          />
        ))}
      </Inside>
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  height: auto;
  overflow: hidden;
`;
const Inside = styled(motion.div)`
  padding-top: 5px;
  display: flex;
  gap: 5px;
  position: relative;
`;

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 },
};

const Button = ({ amount, setAmount }) => {
  const onClick = () => setAmount(amount);

  return (
    <AmountButton
      variants={itemVariants}
      onClick={onClick}
      data-cy="fund-it-amount-button"
    >
      <Background />
      <ButtonInside>${amount}</ButtonInside>
    </AmountButton>
  );
};

const AmountButton = styled(motion.button)`
  flex: 1;
  appearance: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: #525151;
  overflow: hidden;
  position: relative;
  font-size: 20px;
  font-weight: 400;
  font-family: Montserrat;
  line-height: 22px;
  background: none;
`;
const ButtonInside = styled(motion.div)`
  position: relative;
  z-index: 5;
  padding: 6px 0;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.08);
  }
  &:active {
    transform: scale(0.9);
  }
  &:hover:active {
    transform: scale(0.98);
  }
`;
const Background = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.25);
  z-index: 1;
  opacity: 0.4;
  border-radius: 4px;
  transition: opacity 1s;

  ${AmountButton}:hover & {
    transition: opacity 0.2s;
    opacity: 0.75;
  }
  ${AmountButton}:active & {
    transition: opacity 0.2s;
    opacity: 1;
  }
`;
